/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React, { useState } from "react";

import Modal from "../../Modal";
import AwardImportModal from "../award-import/AwardImportModal";
import messages from "../../../helpers/messages";

function AlertModalForSalesRep({ open, handleClose, bidId, user }) {
  const [openAwardImportModal, setOpenAwardImportModal] = useState(false);

  return (
    <>
      {!openAwardImportModal && (
        <Modal
          title={messages.uploadComplete.defaultMessage}
          open={open}
          large={true}
          handleClose={handleClose}
          titleClass="modal__title_light uppercase"
          bodyClass="border-top-grey px-24 pt-24 award-upload"
          closeButtonClass="modal__close-button mr-16 mt-16"
        >
          <p
            data-testid="alert-text"
            className="font-size-16 text-dim-grey mb-0"
          >
            {messages.awardUploadForSalesRepSuccessMessage.defaultMessage}
          </p>
          <div className="grid fr">
            <div className="grid__cell my-24">
              <button
                data-testid="import-award"
                className="primary-button one-whole cursor-pointer univers-67-bold-cond"
                style={{ minWidth: "140px" }}
                onClick={() => setOpenAwardImportModal(true)}
              >
                {messages.importAward.defaultMessage}
              </button>
            </div>
          </div>
        </Modal>
      )}
      {openAwardImportModal && (
        <AwardImportModal
          bidId={bidId}
          user={user}
          handleAwardImportModalClose={() => handleClose(true)}
        />
      )}
    </>
  );
}

export default AlertModalForSalesRep;
